const LANES: Array<{ label: string; color: string }> = [
  { label: "Player", color: "var(--fg-2)" },
  { label: "Operator", color: "var(--cyan)" },
  { label: "Studio", color: "var(--gold-bright)" },
];

const STEPS: Array<{ from: number; to: number; label: string; detail: string }> = [
  { from: 0, to: 1, label: "open game", detail: "player click" },
  { from: 1, to: 2, label: "session/launch", detail: "POST + JWT" },
  { from: 2, to: 1, label: "serverSeedHash", detail: "committed" },
  { from: 1, to: 2, label: "round/open", detail: "debit wallet" },
  { from: 2, to: 0, label: "tick + cracks", detail: "WS 30fps" },
  { from: 0, to: 2, label: "cashout", detail: "round/resolve" },
  { from: 2, to: 1, label: "credit payout", detail: "debit/credit" },
  { from: 2, to: 0, label: "seed reveal", detail: "verify in browser" },
];

export function IntegrationDiagram() {
  return (
    <div
      style={{
        background: "var(--bg-2)",
        border: "1px solid var(--line)",
        borderRadius: "var(--r-lg)",
        padding: 24,
        overflow: "auto",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 0,
          minWidth: 560,
        }}
      >
        {LANES.map((lane) => (
          <div
            key={lane.label}
            style={{
              padding: "10px 0",
              borderBottom: "1px solid var(--line)",
              textAlign: "center",
              fontFamily: "var(--font-ui)",
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: lane.color,
            }}
          >
            {lane.label}
          </div>
        ))}

        {STEPS.map((step, i) => (
          <DiagramRow key={i} step={step} index={i} />
        ))}
      </div>
    </div>
  );
}

function DiagramRow({
  step,
  index,
}: {
  step: (typeof STEPS)[number];
  index: number;
}) {
  const start = Math.min(step.from, step.to);
  const end = Math.max(step.from, step.to);
  const rightward = step.from < step.to;
  return (
    <>
      {[0, 1, 2].map((col) => {
        const inRange = col >= start && col <= end;
        const isArrow = inRange;
        const isFromCell = col === step.from;
        const isToCell = col === step.to;
        return (
          <div
            key={col}
            style={{
              padding: "10px 12px",
              position: "relative",
              borderTop: index === 0 ? "none" : "1px solid var(--line)",
              minHeight: 48,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "var(--font-mono)",
              fontSize: 12,
            }}
          >
            {isArrow ? (
              <div
                style={{
                  position: "absolute",
                  left: col === start ? "50%" : 0,
                  right: col === end ? "50%" : 0,
                  top: "50%",
                  height: 1,
                  background: "var(--line-strong)",
                }}
              />
            ) : null}
            {isFromCell ? (
              <span
                style={{
                  position: "relative",
                  zIndex: 1,
                  background: "var(--bg-2)",
                  padding: "0 8px",
                  color: "var(--fg-1)",
                }}
              >
                {step.label}
              </span>
            ) : null}
            {isToCell && !isFromCell ? (
              <span
                style={{
                  position: "relative",
                  zIndex: 1,
                  background: "var(--bg-2)",
                  padding: "0 6px",
                  color: "var(--fg-3)",
                  fontSize: 10,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                {rightward ? "→" : "←"} {step.detail}
              </span>
            ) : null}
          </div>
        );
      })}
    </>
  );
}
